export const LTlFormStyles = {
  hazmatCheckBox: {
    marginRight: '0',
  },
  hazmatPopOver: {
    backgroundColor: 'white',
    borderRadius: '0',
    textDecoration: 'underline !important',
  },
  tableFooterRow: { 'border-top': '1px solid rgba(224.4, 224.4, 224.4, 1)' },
  totalWeightCell: {
    'text-align': 'center' as const,
    border: 'none',
    'max-width': '100px',
  },
  shipmentTotalCell: { border: 'none', 'max-width': '70px' },
};
